/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getArticle = /* GraphQL */ `
  query GetArticle($id: ID!) {
    getArticle(id: $id) {
      id
      name
      description
      owner
      postedDate
      attachments {
        items {
          id
          contentType
          path
          owner
          articleId
          postedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      labels {
        items {
          id
          articleId
          labelId
          owner
          postedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      positionName
      latitude
      longitude
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listArticles = /* GraphQL */ `
  query ListArticles($filter: ModelArticleFilterInput, $limit: Int, $nextToken: String) {
    listArticles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        owner
        postedDate
        attachments {
          nextToken
          __typename
        }
        labels {
          nextToken
          __typename
        }
        positionName
        latitude
        longitude
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAttachment = /* GraphQL */ `
  query GetAttachment($id: ID!) {
    getAttachment(id: $id) {
      id
      contentType
      path
      owner
      articleId
      postedDate
      article {
        id
        name
        description
        owner
        postedDate
        attachments {
          nextToken
          __typename
        }
        labels {
          nextToken
          __typename
        }
        positionName
        latitude
        longitude
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAttachments = /* GraphQL */ `
  query ListAttachments($filter: ModelAttachmentFilterInput, $limit: Int, $nextToken: String) {
    listAttachments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        contentType
        path
        owner
        articleId
        postedDate
        article {
          id
          name
          description
          owner
          postedDate
          positionName
          latitude
          longitude
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLabel = /* GraphQL */ `
  query GetLabel($id: ID!) {
    getLabel(id: $id) {
      id
      name
      color
      owner
      postedDate
      articles {
        items {
          id
          articleId
          labelId
          owner
          postedDate
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLabels = /* GraphQL */ `
  query ListLabels($filter: ModelLabelFilterInput, $limit: Int, $nextToken: String) {
    listLabels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        color
        owner
        postedDate
        articles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getArticleLabelJoin = /* GraphQL */ `
  query GetArticleLabelJoin($id: ID!) {
    getArticleLabelJoin(id: $id) {
      id
      articleId
      labelId
      owner
      postedDate
      article {
        id
        name
        description
        owner
        postedDate
        attachments {
          nextToken
          __typename
        }
        labels {
          nextToken
          __typename
        }
        positionName
        latitude
        longitude
        createdAt
        updatedAt
        __typename
      }
      label {
        id
        name
        color
        owner
        postedDate
        articles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listArticleLabelJoins = /* GraphQL */ `
  query ListArticleLabelJoins(
    $filter: ModelArticleLabelJoinFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticleLabelJoins(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        articleId
        labelId
        owner
        postedDate
        article {
          id
          name
          description
          owner
          postedDate
          positionName
          latitude
          longitude
          createdAt
          updatedAt
          __typename
        }
        label {
          id
          name
          color
          owner
          postedDate
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listArticlesByDate = /* GraphQL */ `
  query ListArticlesByDate(
    $owner: String
    $postedDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticlesByDate(
      owner: $owner
      postedDate: $postedDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        owner
        postedDate
        attachments {
          items {
            id
            contentType
            path
            owner
            articleId
            postedDate
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        labels {
          items {
            id
            articleId
            labelId
            owner
            postedDate
            label {
              id
              name
              color
              owner
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        positionName
        latitude
        longitude
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAttachmentsByDate = /* GraphQL */ `
  query ListAttachmentsByDate(
    $owner: String
    $postedDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAttachmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAttachmentsByDate(
      owner: $owner
      postedDate: $postedDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contentType
        path
        owner
        articleId
        postedDate
        article {
          id
          name
          description
          owner
          postedDate
          positionName
          latitude
          longitude
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
